var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":_vm.appLogo,"alt":"site logo","height":"65"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }